module.exports = __webpack_public_path__ + "static/img/home-scene-01.d34a981.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/home-scene-01.jpg
// module id = JbXE
// module chunks = 13